var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-table',{attrs:{"store-name":"payments","query-filter":_vm.queryFilter,"headers":_vm.headers}})
}
var staticRenderFns = []

export { render, staticRenderFns }